// extracted by mini-css-extract-plugin
export default {"content":"DataHintModalContent_content__WPpZK","content__list":"DataHintModalContent_content__list__cGG-z"};